module.exports = __webpack_public_path__ + "img/3-7686.45ae4ba9.png";